import { UtilizationPanel } from '@cdk-prod/fortellis-app-utilization-component';
import React, { useContext, useEffect, useState } from 'react';
import { theme, Loader } from 'cdk-radial';
import { useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import localeData from '@cdk-prod/fortellis-app-utilization-component/src/locales/data.json';
import { environmentURLs } from '../../../common/CaptureEnvironment';
import { UTILIZATION_REPORT_THEME } from '../../../../constants/constants';

const locale = 'en';
const messages = localeData['en'];
const utilizationReportTheme = UTILIZATION_REPORT_THEME.DEALER_UTILIZATION_REPORT;


export const Utilization = () => {
  const state = useSelector((state) => state);

  const { authenticationToken: token, fortellisEnterpriseEntityId } =
    state?.loginDetailsSlice;

  const { orders } = state?.orderAPISlice;
  const { app } = orders;

  const [solutions, setSolutions] = useState([]);
  const [utilizationByAPI, setUtilizationByAPI] = useState([]);
  const [pageIsLoading, setPageIsLoading] = useState(true);
  const [solutionId, setSolutionId] = useState('');

  const startDate = moment()
    .startOf('month')
    .startOf('day')
    .format('YYYY-MM-DD HH:mm:ss');

  const endDate = moment()
    .startOf('month')
    .startOf('day')
    .format('YYYY-MM-DD HH:mm:ss');

  const fetchSolutions = async (solutionId) => {
    try {
      const response = await axios.get(
        `${environmentURLs.REACT_APP_API_EMAIL_SOLUTION_SERVICE}/v1/solutions/${solutionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data } = response;
      const solutionData = {
        id: data.id,
        overview: { name: data.name },
      };
      const solutionDataArray = [solutionData];
      return solutionDataArray;
    } catch (error) {
      console.error('fetch solutions is not successful', error);
    }
  };

  const getUtilizationData = async ({ solutionId, startDate, endDate }) => {
    try {
      const appId = solutionId;
      const response = await axios.get(
        `${environmentURLs.REACT_APP_UTILIZATION_SERVICE_URL}/v1/apps/${appId}/utilization`,
        {
          params: {
            appId,
            startDate: moment(startDate)
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment(endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const utilizationByAPI = response.data.items;
      const res = {
        data: { getUtilization: { utilizationByAPI: utilizationByAPI } },
      };
      return res;
    } catch (error) {
      console.error('Error fetching utilization data:', error);
    }
  };

  const fetchData = async (solutionId) => {
    try {
      const [solutionResData, utilizationResData] = await Promise.all([
        fetchSolutions(solutionId),
        getUtilizationData({ solutionId, startDate, endDate }),
      ]);
      setSolutions(solutionResData);
      setUtilizationByAPI(
        utilizationResData?.data?.getUtilization?.utilizationByAPI
      );
    } catch (error) {
      console.error('Error fetching solution data and utilization data', error);
    } finally {
      setPageIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(app?.id);
    setSolutionId(app?.id);
  }, []);

  return (
    <>
      {pageIsLoading ? (
        <div className="api-details-loading-provisiong">
          <Loader />
          <div className="loader-text">
            <p>Fetching Utilization Report...</p>
          </div>
        </div>
      ) : (
        <IntlProvider locale={locale} messages={messages}>
          <ThemeProvider theme={theme}>
            <UtilizationPanel
              belongsTo={utilizationReportTheme}
              solutionId={solutionId}
              utilizationByAPI={utilizationByAPI}
              getUtilizationData={getUtilizationData}
              startDate={startDate}
              endDate={endDate}
              entity={fortellisEnterpriseEntityId}
              solutions={solutions}
            />
          </ThemeProvider>
        </IntlProvider>
      )}
    </>
  );
};
